module.exports = __webpack_public_path__ + "img/level1.a79a34de.jpg";